<template>
  <div class="wrapper">
    <div class="container">
      <div class="title">
        <div class="title_info">
          <div class="info">
            <p class="tip1">欢迎您：{{userInfo.name}}</p>
            <div class="name">
              <p>所属机构：{{deptInfo.orgName}}</p>
              <p class="line"></p>
              <p>{{deptInfo.name}}</p>
            </div>
          </div>
          <div class="myOperation">
            <div class="mySupervisor" @click="toHandlePage">
              <img src="../../../../assets/complaint/Rectangle@3x.png" alt />
              <span>督办</span>
            </div>
            <div class="myFocus" @click="toAttentionPage">
              <img src="../../../../assets/complaint/Star@3x.png" alt />
              <span>关注</span>
            </div>
          </div>
        </div>
      </div>
      <div class="check_list">
        <div class="item">
          <div class="t_text statistics">
            <div class="t_text adress" @click="showAreaPicker"><span>{{formData.city | ellipsis}}</span><img v-show="Number(deptInfo.areaLevel) < '3'" src="../../../../assets/complaint/ic_jiantou_down  2@2x.png" alt=""></div>
            <div class="button">
              <span class="button_list" v-for="(item,index1) in dateDataList" :key="index1" @click="item.value ? toCountDetailByDatePage(item) : ''">{{item.name}}{{item.value}}</span>
            </div>
          </div>
          <div class="box">
            <div class="left line line_bottom " :class="{'line_right':index%2==0}" v-for="(item, index) in handlingList" :key='index' @click="toCountDetailByStatusPage(item.type,formData.cityId)">
              <p class="status">{{item.name}}(件)</p>
              <div class="num">
                <span></span>
                <span>{{item.value}}</span>
              </div>
            </div>
            <div class="fallPointDistribution line_bottom">
                <div class="status">落点分布</div>
                <div class="levelDistribution">
                    <div class="districtLevel" @click="toPlaceDetailPage(1)">
                        <div class="leaveName">省级</div>
                        <div class="pointsNum">{{dropDistribution.province||0}}</div>
                    </div>
                    <div class="levelPointing">
                      <img src="../../../../assets/index/right2x.png" alt="">
                    </div>
                    <div class="districtLevel" @click="toPlaceDetailPage(2)">
                        <div class="leaveName leaveName1">州市</div>
                        <div class="pointsNum">{{dropDistribution.city||0}}</div>
                    </div>
                    <div class="levelPointing">
                      <img src="../../../../assets/index/right2x.png" alt="">
                    </div>
                    <div class="districtLevel" @click="toPlaceDetailPage(3)">
                        <div class="leaveName leaveName2">区县</div>
                        <div class="pointsNum" >{{dropDistribution.county||0}}</div>
                    </div>
                    <div class="levelPointing">
                      <img src="../../../../assets/index/right2x.png" alt="">
                    </div>
                    <div class="districtLevel">
                        <div class="leaveName leaveName3" @click="toPlaceDetailPage(4)">企业</div>
                        <div class="pointsNum">{{dropDistribution.enterprise||0}}</div>
                    </div>
                    <div class="levelPointing"></div>
                </div>
            </div>
            <div class="complaintStatistics" @click="toDataViewPage">
              <router-link to='/complaint/visual' class="routeText"><span>数据可视化</span> <img src="../../../../assets/image/complaint_right.png" alt=""></router-link>
            </div>
          </div>
        </div>
        <div class="item">
          <p class="t_text">近30天投诉数据</p>
          <div class="box linecharts">
            <lineCharts :data="lineData" color="green" :showYear="true" unit="件"/>
          </div>
        </div>
        <div class="item" v-show="syntheticalWarningList.length">
          <p class="t_text">综合预警</p>
          <div class="box comprehensiveWarning">
            <van-swipe
              :autoplay="3000"
              indicator-color="#bbbbbb"
            >
              <van-swipe-item v-for="(item,index1) in syntheticalWarningList" :key="index1" @click="toWrningDetailPage('syntheticalWarning',item.typeCode,formData.cityId)">
                <div class="area">
                  <span>{{item.name}}</span>
                </div>
                <div class="totalComplaints">
                  <span>{{item.warning}}，{{item.description}}</span>
                </div>
                <div class="deadline">
                  <span>{{item.time}}</span>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <div class="item" v-show="timeLimitList.length">
          <p class="t_text">时限预警</p>
          <div class="box timeLimit">
            <div class="blueWarning" v-for="(item,index) in timeLimitList" :key="index" @click="toTimeWarningPage('timeLimit',item.type,formData.cityId)">
              <div class="warningTitle">{{item.name}}(件)</div>
              <div class="warningNum blue">{{item.value}}</div>
            </div>
          </div>
        </div>
        <div class="item" v-show="emergencyList.length">
          <p class="t_text">紧急程度</p>
          <div class="box timeLimit">
            <div class="blueWarning" v-for="(item,index) in emergencyList" :key="index" @click="toTimeWarningPage('emergency',item.type,formData.cityId)">
              <div class="warningTitle">{{item.name}}</div>
              <div class="warningNum blue">{{item.value}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <common-picker
      v-if="areaList.length"
      ref="commonPicker"
      :typeList="areaList"
      :cols="formData.cols"
      @getTypeValue="getCityValue"
    ></common-picker>
  </div>
</template>
<script>
    import API from './../../../../service/modules/complaintApis'
    import lineCharts from '@/components/LineCharts';
    import commonPicker from '../../../../components/base/commonPicker';
    import util from '../../../../utils/common'
    export default {
        components: {
            lineCharts,
            commonPicker
        },
        data () {
            return {
                // 用户数据
                userInfo: {},
                // 部门信息
                deptInfo: {},
                // 区域列表
                areaList: [],
                // 条件选择或跳转条件参数
                formData: {
                    cityId: '',
                    citycode: '',
                    city: '-',
                    cols: 2
                },
                // 日期单位维度数据
                dateDataList: [
                    { value: '0', name: '今天' },
                    { value: '0', name: '本周' },
                    { value: '0', name: '本月' },
                    { value: '0', name: '全部' }
                ],
                // 近30天投诉数据
                lineData: [],
                // 行政区投诉件数/落点分布数据
                dropDistribution: {},
                // 综合预警数据
                syntheticalWarningList: [],
                // 时限预警数据
                timeLimitList: [],
                // 紧急程度数据
                emergencyList: [],
                // 处理状态统计数据
                handlingList: [
                    { value: '0', name: '待响应' },
                    { value: '0', name: '处理中' },
                    { value: '0', name: '即将超时' },
                    { value: '0', name: '超时未办结' }
                ]
            };
        },
        filters: {
            ellipsis (value) {
                if (!value) return ''
                if (value.length > 5) {
                    return value.substring(0, 5) + '...'
                }
                return value
            }
        },
        created () {
            util.setJsonLocal('buttonType','queryList');
            util.setJsonLocal('waitResponse','');
            this.getUserInfo();
            // this.getNoticeNum();
            this.initData();
        },
        methods: {
            // 拉取待办数量
            // getNoticeNum () {
            //     this.$store.dispatch('notice/getComplainNum')
            // },
            initData (params = {}) {
                this.getDateData(params); // 时间粒度统计数据
                this.getSatusData(params); // 状态统计数据
                this.getDropDistribution(params); // 落点分布（行政区域）统计数据
                this.getTrendData(params); // 近30天投诉统计数据
                this.getWarninngData(params); // 综合预警投诉统计数据
                this.getTimeLimitData(params); // 时限预警投诉统计数据
                this.getEmergencyData(params); // 紧急程度投诉统计数据
            },
            // 获取用户信息和部门信息
            getUserInfo () {
                API.common.user({}).then(res => {
                    if (res.ret === 0) {
                        this.userInfo = Object.assign({}, res.data.userInfo, res.data);
                        this.deptInfo = (res.data.depts || [])[0] || {}; // 部门信息
                        this.formData.citycode = this.deptInfo.areaCode;
                        this.formData.cityId = this.deptInfo.txId;
                        this.formData.city = this.deptInfo.areaName;
                        util.setJsonLocal('userInfoComplaint',res.data);
                        this.$store.commit('complaint/setUserInfo', this.userInfo);
                        this.$store.commit('complaint/setDeptInfo', this.deptInfo);
                        // 获取组织列表数据
                        this.getAllCity();
                    }
                })
            },
            // 获取时间粒度统计数据
            getDateData (params = {}) {
                API.leader.getCountByTime(params).then(res => {
                    if (res.ret) return false;
                    const list = res.data.complainStatistics || []
                    this.dateDataList.splice(0, this.dateDataList.length);
                    this.dateDataList.push(...list);
                });
            },
            // 获取状态统计数据
            getSatusData (params = {}) {
                API.leader.getCountByAllStatus(params).then(res => {
                    if (res.ret) return false;
                    const list = res.data.handling || []
                    this.handlingList.splice(0, this.handlingList.length);
                    this.handlingList.push(...list);
                });
            },
            // 获取落点分布数据
            getDropDistribution (params = {}) {
                API.leader.getCountByPlace(params).then(res => {
                    if (res.ret) return false;
                    this.dropDistribution = res.data.dropDistribution;
                });
            },
            // 获取近30天投诉统计数据
            getTrendData (params = {}) {
                API.common.trend(params).then(res => {
                    if (res.ret === 0) {
                        if (res.data.trend && res.data.trend.length > 0) {
                            let arr = [];
                            res.data.trend.map(item => {
                                arr.push({ xAxis: item.day.substr(5), num: item.num + '' })
                            })
                            this.lineData = arr.reverse();
                        }
                    }
                })
            },
            // 获取综合预警投诉统计数据
            getWarninngData (params = {}) {
                API.common.queryAllsyntheticalWarning(params).then(res => {
                    if (res.ret === 0) {
                        const list = (res.data.syntheticalWarning || {}).list || []
                        this.syntheticalWarningList.splice(0, this.syntheticalWarningList.length);
                        this.syntheticalWarningList.push(...list);
                    }
                })
            },
            // 获取时限预警投诉统计数据
            getTimeLimitData (params = {}) {
                API.common.queryAlltimeLimit(params).then(res => {
                    if (res.ret === 0) {
                        const list = res.data.timeLimit || []
                        this.timeLimitList.splice(0, this.timeLimitList.length);
                        this.timeLimitList.push(...list);
                    }
                })
            },
            // 获取紧急程度投诉统计数据
            getEmergencyData (params = {}) {
                API.common.queryAllemergency(params).then(res => {
                    if (res.ret === 0) {
                        const list = res.data.emergency || []
                        this.emergencyList.splice(0, this.emergencyList.length);
                        this.emergencyList.push(...list);
                    }
                })
            },
            // 显示区域选择器
            showAreaPicker () {
                if (this.deptInfo.areaLevel === '3') return;
                this.$refs.commonPicker.showPicker();
            },
            // 跳转督办页面
            toHandlePage () {
                let obj = {
                    key: 'leaderHandle'
                }
                this.$store.commit('complaint/setListType', obj);
                this.$router.push({
                    path: '/complaint/handle',
                    query: {
                        fullAddress: this.formData.city,
                        areaOne: this.formData.cityId,
                        value: this.formData.citycode
                    }
                })
            },
            // 跳转关注页面
            toAttentionPage () {
                let obj = {
                    key: 'attention'
                }
                this.$store.commit('complaint/setListType', obj);
                this.$router.push({
                    path: '/complaint/attention',
                    query: {
                        fullAddress: this.formData.city,
                        areaOne: this.formData.cityId,
                        value: this.formData.citycode
                    }
                })
            },
            // 跳转数据可视化页面
            toDataViewPage () {
                let obj = {
                    fullAddress: this.formData.city,
                    areaOne: this.formData.cityId,
                    value: this.formData.citycode
                }
                this.$store.commit('complaint/setWorkType', obj);
                this.$router.push({
                    path: '/complaint/visual',
                    query: { fullAddress: this.formData.city, areaOne: this.formData.cityId }
                })
            },
            // 跳转投诉状态统计详情页面
            toCountDetailByStatusPage (item, areaOne) {
                const obj = {
                    key: 'check',
                    type: item,
                    areaOne: this.formData.cityId
                }
                this.$store.commit('complaint/setListType', obj);
                this.$router.push({
                    path: '/complaint/leaderListFirst',
                    query: {
                        type: item,
                        areaOne: areaOne
                    }
                })
            },
            // 跳转时限预警页面
            toTimeWarningPage (type, value, cityId) {
                this.$router.push({
                    path: '/complaint/timeLimitList',
                    query: {
                        typeSign: type,
                        dafaultType: value,
                        areaOne: cityId
                    }
                })
            },
            // 跳转综合预警详情
            toWrningDetailPage (type, value, area) {
                this.$router.push({
                    path: '/complaint/comprehensiveWarningList',
                    query: {
                        type: type,
                        warningType: value,
                        place: area
                    }
                });
            },
            // 按投诉时间粒度统计详情跳转
            toCountDetailByDatePage (item) {
                this.$store.commit('complaint/setTodayType', item.type);
                setTimeout(() => {
                  this.$router.push({
                      path: '/complaint/leadList1',
                      query: {
                          name: item.type,
                          city: this.formData.city,
                          areaId: this.formData.cityId
                      }
                  });
                }, 500)
            },
            // 跳转落点分布详情
            toPlaceDetailPage (value) {
                let obj = {
                    key: 'dropDistribution',
                    typeSign: 'dropDistribution',
                    dafaultType: value,
                    areaOne: this.formData.cityId
                }
                this.$store.commit('complaint/setListType', obj);
                this.$router.push({
                    path: '/complaint/leaderListSec',
                    query: {
                        typeSign: 'dropDistribution',
                        dafaultType: value,
                        areaOne: this.formData.cityId
                    }
                })
            },
            // 获取所选择的regioncode
            getCityValue (value) {
                this.formData.cityId = value[value.length - 1].areaId;
                if (value[1].areaId) {
                    this.formData.city = value[1].label
                    this.formData.citycode = value[1].value
                    const params = {
                        areaOne: value[0].areaId,
                        areaTwo: value[1].areaId
                    }
                    this.initData(params)
                } else {
                    this.formData.citycode = value[0].value;
                    this.formData.city = value[0].label
                    const params = {
                        areaOne: value[0].areaId
                    }
                    this.initData(params)
                }
            },
            // 初始化区域数据列表
            getAllCity () {
                // 获取所有的市
                const params = {
                    data: {
                        cityCode: this.deptInfo.txId
                    }
                };
                this.$store.dispatch('complaint/region', params).then(data => {
                    this.formData.city = data[0].text
                    // 当前用户所属城市下级城市列表
                    if (this.deptInfo.areaLevel === '1') {
                        this.formData.cols = 2;
                    } else if (this.deptInfo.areaLevel === '2') { // 省级权限
                        this.formData.cols = 2;
                    } else { // 区县权限
                        this.formData.cols = 1;
                    }
                    this.areaList = [data];
                    this.$nextTick(() => {
                        this.$refs.commonPicker && this.$refs.commonPicker._initFresh();
                    })
                });
            }
        }
    };
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  overflow: hidden;
  background-color: #fafafa;
  .container {
    width: 100%;
    .title {
      width: 100%;
      height: 121px;
      background-color: @base-color;
      position: relative;
      overflow: hidden;
      .title_info {
        width: 100%;
        padding: 0 16px 0 16px;
        height: 121px;
        box-sizing: border-box;
        overflow: hidden;
        .tip1 {
          font-size: 12px;
          margin-top: 20px;
          color: #ffffff;
        }
        .name {
          margin-top: 10px;
          display: flex;
          height: 12px;
          p {
            display: inline-block;
            vertical-align: middle;
            font-size: 12px;
            color: #ffffff;
          }
          .line {
            content: '';
            margin: 2px 5px;
            background: #ebedf0;
            width: 1px;
            height: 18px;
            -webkit-transform: scaleY(0.5);
            transform: scale(0.5);
            -webkit-transform-origin: 0 0;
            transform-origin: 0 0;
            margin-top:0px;
          }
        }
        .tip2 {
          font-size: 14px;
          color: #ccc;
          margin-top: 13px;
        }
        .myOperation {
          font-size: 14px;
          color: #ffffff;
          font-weight: Regular;
          margin-top: 30px;
          width: 100%;
          display: flex;
          .mySupervisor,
          .myFocus {
            flex: 1;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              display: inline-block;
              float: left;
              width: 20px;
              // margin-left: 45px;
            }
            span {
              margin-left: 8px;
            }
          }
        }
      }
    }
    .check_list {
      width: 100%;
      padding: 0 12px 20px 12px;
      box-sizing: border-box;
      .item {
        width: 100%;
        .t_text {
          font-size: 20px;
          color: #333;
          margin-top: 28px;
          font-weight: 700;

        }
        .statistics {
          height: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 21px;
          .adress {
            display: inline-block;
            margin-top: 0;
            float: left;
            font-size: 14px;
            line-height: 20px;
            span {
              display: inline-block;
              float: left;
            }
            img {
              display: inline-block;
              float: right;
              width: 6px;
              height: 4px;
              margin-top: 8px;
              margin-left: 5px;
            }
          }
          .button {
            float: right;
            display: flex;
            // height: 20px;
            font-size:0;
            .button_list{
              display: inline-block;
              padding:5px 7px 3px 7px;
              font-size:12px;
              color:#333;
              background-color: #fff;
              border-radius: 16px 16px;
              margin-right: 10px;
              font-weight: 400;
              position: relative;
              border: none;
            }
            .button_list:after {
              content: " ";
              position: absolute;
              left: 0;
              top: 0;
              width: 200%;
              height: 200%;
              border: 1px solid #DFDFDF;
              -webkit-transform-origin: 0 0;
              border-radius: 16px 16px;
              transform-origin: 0 0;
              -webkit-transform: scale(0.5);
              transform: scale(0.5);
            }
            .button_list:nth-child(4){
              margin-right:0;
            }
          }
        }
        .box {
          width: 100%;
          margin-top: 12px;
          box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
          border-radius: 4px;
          font-size: 0;
          background: #ffffff;
          .left {
            width: 50%;
            height: 100px;
            display: inline-block;
            text-align: center;
            .num {
              span:nth-child(1) {
                font-size: 30px;
                color: @base-color;
                display: inline-block;
                vertical-align: bottom;
                font-weight: 700;
              }
              span:nth-child(2) {
                color: #36b374;
                display: inline-block;
                vertical-align: bottom;
                margin-left: 4px;
                margin-top: 8px;
                font-size: 32px;
                line-height:32px;
                font-family:PingFangSC-Regular,PingFang SC;
                -webkit-font-smoothing: antialiased;
                font-weight: 700;
              }
            }
            .status {
              margin-top: 24px;
              font-size: 12px;
              color: #333333;
              font-weight: Regular;
            }
          }
          .complaintStatistics {
            height: 40px;
            width: 100%;
            // font-size: 12px;
            font-weight: Regular;
            color: #9b9b9b;
            line-height: 40px;
            text-align: center;
            .routeText {
              display: flex;
              justify-content: center;
              align-items: center;
              font-size:14px;
              img {
                width: 5px;
                height: 8px;
                margin-left: 5px;
                margin-top:0;
                // margin-top: 2px;
              }
            }

          }
          .fallPointDistribution {
                height: 130px;
                width: 100%;
                overflow: hidden;
                .status {
                    font-size: 16px;
                    color: #333333;
                    font-weight: bold;
                    width: 100%;
                    text-align: center;
                    margin-top: 23px;
                }
            .levelDistribution {
                height: 35px;
                display: flex;
                .districtLevel {
                    flex: 1;
                    padding-top: 30px;
                    height: 80px;
                    .leaveName {
                        font-size: 14px;
                        color: #36B374;
                        font-weight: bold;
                        text-align: center;
                    }
                    .leaveName1{
                      color: rgba(54, 179, 116, 0.8);
                    }
                    .leaveName2{
                      color: rgba(54, 179, 116, 0.6);
                    }
                    .leaveName3{
                      color: rgba(54, 179, 116, 0.4);
                    }
                    .pointsNum {
                        font-weight: Regular;
                        font-size: 13px;
                        color: #333333;
                        text-align: center;
                        margin-top: 8px;
                    }
                }
                .levelPointing {
                    width: 7px;
                    height: 34px;
                    margin-top: 30px;
                }
            }
          }
          .complaintStatistics {
              height: 40px;
              width: 100%;
              font-size: 12px;
              font-weight: Regular;
              color: #999999;
              line-height: 40px;
              text-align: center;
          }
        }
        .price {
          display: flex;
          display: -webkit-flex;
          flex-direction: column;
          justify-content: space-between;
          .p_item {
            // text-align: center;
            margin-top: 30px;
            .money {
              font-size: 25px;
              color: #1890ff;
              font-weight: 700;
            }
            .about_statu {
              font-size: 12px;
              color: #7d7d7d;
              margin-top: 15px;
            }
          }
        }
        .total {
          font-size: 16px;
          color: #2a2a2a;
          margin-top: 50px;
        }
        .item_price {
          width: 100%;
          .get_price {
            // text-align: center;
            margin-left: 80px;
            span:nth-child(1) {
              display: inline-block;
              width: 10px;
              height: 10px;
              vertical-align: middle;
              background-color: #50aeff;
            }
            span:nth-child(2) {
              display: inline-block;
              font-size: 13px;
              color: #7d7d7d;
              vertical-align: middle;
            }
          }
          .success_price {
            margin-top: 15px;
          }
        }
        .other_price {
          margin-top: 50px;
        }
        .fail_price {
          width: 100%;
          height: 60px;
          line-height: 60px;
          border-bottom: 1px solid #efefef;
          span {
            font-size: 14px;
            color: #4a4a4a;
          }
          span:nth-child(1) {
            float: left;
          }
          span:nth-child(2) {
            float: right;
          }
        }
        .day_info {
          font-size: 16px;
          color: #2a2a2a;
          margin-top: 50px;
        }
        //空白图表
        .linecharts {
          width: 100%;
          height: 234px;
        }
        .comprehensiveWarning {
          width: 100%;
          height: 131px;
          .van-swipe {
            height: 100%;
            .van-swipe__indicators {
              bottom: 20px;
              .van-swipe__indicator {
                background-color: #e9e9e9 !important;
              }
            }
          }
          .van-swipe-item {
            font-size: 14px;
            text-align: center;
            .area {
              margin-top: 24px;
              color: #36b374;
              font-size: 16px;
              font-weight: Semibold;
              font-weight: bold;
            }
            .totalComplaints {
              font-size: 14px;
              font-weight: Light;
              color: #333333;
              margin-top: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding: 0 16px;
              line-height: 18px;
            }
            .deadline {
              font-size: 12px;
              color: #999999;
              font-weight: Light;
              margin-top: 12px;
            }
          }
        }
        .timeLimit {
          font-size: 14px;
          height: 100px;
          display: flex;
          padding: 0 10px;
          .blueWarning,
          .yellowWarning,
          .redWarning {
            flex: 1;
            margin-top: 24px;
            .warningTitle {
              font-size: 12px;
              color: #333333;
              font-weight: Regular;
              text-align: center;
            }
            .warningNum {
              font-size: 32px;
              // font-weight: Bold;
              margin-top: 8px;
              text-align: center;
              // font-family:DIN-Bold,DIN;
              font-family:PingFangSC-Regular,PingFang SC;
              -webkit-font-smoothing: antialiased;
              font-weight: 700;
            }
            .blue {
              color: #118bf5;
            }
            .yellow {
              color: #ffa509;
            }
            .red {
              color: #f75c32;
            }
          }
        }
        .timeLimit .blueWarning:nth-child(2) .warningNum{
           color:#FFA509
        }
        .timeLimit .blueWarning:nth-child(3) .warningNum{
           color:#F75C32
        }
      }
    }
  }
  /deep/ .van-button--mini{
    font-size:12px!important;
    padding:0 7px;
  }
}
</style>
<style>
#mountNode {
  /* width:400px;
      height:200px; */
}
.home_price {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
  font-size: 20px;
  color: #1890ff;
}
.chart-wrapper {
  text-align: center;
  position: relative;
}
.chart-wrapper1 {
  text-align: center;
}
</style>
